import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import loadable from '@loadable/component';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import usePDPInfoSections from '../PDPInfoSections/usePDPInfoSections';

// Rendered closed from the first render, so the lazy chunk never suspends on a tap
const AnimateHeight = loadable(() => import('react-animate-height'));
const DURATION = 300;
// Starts fast and settles slowly, where the default ease stops abruptly
const EASING = 'cubic-bezier(0.2, 0, 0, 1)';

// Mobile counterpart to PDPInfoTabs: four tab labels do not fit on a phone, so
// the same sections stack as expandable rows. Panels stay mounted while closed
// so a section that loads its own media is not torn down on every toggle.
const PDPInfoAccordionInner = () => {
  const $ = _c(14);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      stacked: true
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const items = usePDPInfoSections(t0);
  const [openId, setOpenId] = useState(null);
  const stopHoldRef = useRef(null);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => () => stopHoldRef.current?.();
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[3] !== items || $[4] !== openId) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const holdAgainstCollapse = panels => {
        const totalHeight = () => panels.reduce(_temp, 0);
        let lastHeight = totalHeight();
        const observer = new ResizeObserver(() => {
          const height = totalHeight();
          window.scrollBy(0, height - lastHeight);
          lastHeight = height;
        });
        const timer = setTimeout(() => stopHoldRef.current?.(), DURATION + 100);
        panels.forEach(panel_0 => observer.observe(panel_0));
        stopHoldRef.current = () => {
          observer.disconnect();
          clearTimeout(timer);
          stopHoldRef.current = null;
        };
      };
      const toggle = (id, index) => {
        stopHoldRef.current?.();
        const panelsAbove = items.slice(0, index).map(_temp2).filter(Boolean);
        if (panelsAbove.some(_temp3)) {
          holdAgainstCollapse(panelsAbove);
        }
        setOpenId(openId === id ? null : id);
      };
      if (!items.length) {
        let t7;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
          t7 = <div className="PDPInfoAccordion__filler" />;
          $[9] = t7;
        } else {
          t7 = $[9];
        }
        t6 = t7;
        break bb0;
      }
      t3 = "mt-8";
      t4 = "PDPInfoAccordion";
      t5 = items.map((t7, index_0) => {
        const {
          id: id_0,
          label,
          content
        } = t7;
        const isOpen = openId === id_0;
        return <div key={id_0} className="border-t border-gray-light7"><button type="button" aria-expanded={isOpen} aria-controls={`${id_0}-panel`} className="bg-transparent border-0 cursor-pointer flex items-center justify-between py-4 px-0 text-left w-full" onClick={() => toggle(id_0, index_0)}><span className="text-base font-bold text-gray">{label}</span><span aria-hidden="true" className="relative shrink-0 w-3.5 h-3.5"><span className="absolute inset-x-0 top-1/2 h-px -translate-y-1/2 bg-gray-light1" /><span className={classNames("absolute inset-y-0 left-1/2 w-px -translate-x-1/2 bg-gray-light1 transition-transform duration-300 ease-out", {
                "rotate-90": isOpen
              })} /></span></button><AnimateHeight id={`${id_0}-panel`} animateOpacity={true} duration={DURATION} easing={EASING} height={isOpen ? "auto" : 0}><div className="pb-6">{content}</div></AnimateHeight></div>;
      });
    }
    $[3] = items;
    $[4] = openId;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
  }
  if (t6 !== Symbol.for("react.early_return_sentinel")) {
    return t6;
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
    t7 = <div className={t3} data-xc={t4}>{t5}</div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
const PDPInfoAccordion = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SuspenseWithLoader><PDPInfoAccordionInner /></SuspenseWithLoader>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default PDPInfoAccordion;
function _temp(sum, panel) {
  return sum + panel.offsetHeight;
}
function _temp2(item) {
  return document.getElementById(`${item.id}-panel`);
}
function _temp3(panel_1) {
  return panel_1.offsetHeight > 0;
}